import { jsx as Re } from "react/jsx-runtime";
import le, { forwardRef as oe, useMemo as Ee, useState as P, useRef as Q, useImperativeHandle as ue, useEffect as ne, useCallback as Ve, useLayoutEffect as Ne } from "react";
var b = (a) => a.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"), Ce = { k: 1e3, m: 1e6, b: 1e9 }, De = (a, r = ".") => {
  let e = new RegExp(`(\\d+(${b(r)}\\d*)?)([kmb])$`, "i"), l = a.match(e);
  if (l) {
    let [, i, , t] = l, n = Ce[t.toLowerCase()];
    return Number(i.replace(r, ".")) * n;
  }
}, Fe = (a, r = ",") => {
  let e = new RegExp(b(r), "g");
  return a.replace(e, "");
}, ke = (a, r) => {
  let e = b(r.join("")), l = new RegExp(`[^\\d${e}]`, "gi");
  return a.replace(l, "");
}, J = ({ value: a, groupSeparator: r = ",", decimalSeparator: e = ".", allowDecimals: l = !0, decimalsLimit: i = 2, allowNegativeValue: t = !0, disableAbbreviations: n = !1, prefix: o = "", transformRawValue: u = (m) => m }) => {
  let m = u(a);
  if (m === "-") return m;
  let f = n ? [] : ["k", "m", "b"], w = new RegExp(`((^|\\D)-\\d)|(-${b(o)})`).test(m), [R, L] = RegExp(`(\\d+)-?${b(o)}`).exec(a) || [], p = o ? R ? m.replace(R, "").concat(L) : m.replace(o, "") : m, g = Fe(p, r), $ = ke(g, [r, e, ...f]), x = $;
  if (!n) {
    if (f.some((N) => N === $.toLowerCase().replace(e, ""))) return "";
    let D = De($, e);
    D && (x = String(D));
  }
  let V = w && t ? "-" : "";
  if (e && x.includes(e)) {
    let [D, N] = $.split(e), T = i && N ? N.slice(0, i) : N, _ = l ? `${e}${T}` : "";
    return `${V}${D}${_}`;
  }
  return `${V}${x}`;
}, Ie = (a, r, e) => {
  if (e !== void 0 && a.length > 1) {
    if (e === 0) return a.replace(r, "");
    if (a.includes(r)) {
      let [t, n] = a.split(r);
      if (n.length === e) return a;
      if (n.length > e) return `${t}${r}${n.slice(0, e)}`;
    }
    let l = a.length > e ? new RegExp(`(\\d+)(\\d{${e}})`) : new RegExp("(\\d)(\\d+)"), i = a.match(l);
    if (i) {
      let [, t, n] = i;
      return `${t}${r}${n}`;
    }
  }
  return a;
}, ce = (a, { groupSeparator: r = ",", decimalSeparator: e = "." }) => {
  let l = new RegExp(`\\d([^${b(r)}${b(e)}0-9]+)`), i = a.match(l);
  return i ? i[1] : void 0;
}, M = (a) => {
  let { value: r, decimalSeparator: e, intlConfig: l, decimalScale: i, prefix: t = "", suffix: n = "" } = a;
  if (r === "" || r === void 0) return "";
  if (r === "-") return "-";
  let o = new RegExp(`^\\d?-${t ? `${b(t)}?` : ""}\\d`).test(r), u = e !== "." ? Le(r, e, o) : r;
  e && e !== "-" && u.startsWith(e) && (u = "0" + u);
  let { locale: m, currency: f, ...w } = l || {}, R = { ...w, minimumFractionDigits: i || 0, maximumFractionDigits: 20 }, L = (l ? new Intl.NumberFormat(m, { ...R, ...f && { style: "currency", currency: f } }) : new Intl.NumberFormat(void 0, R)).formatToParts(Number(u)), p = Ae(L, a), g = ce(p, { ...a }), $ = r.slice(-1) === e ? e : "", [, x] = u.match(RegExp("\\d+\\.(\\d+)")) || [];
  return i === void 0 && x && e && ((t ? p.replace(t, "") : p).includes(e) ? p = p.replace(RegExp(`(\\d+)(${b(e)})(\\d+)`, "g"), `$1$2${x}`) : g && !n ? p = p.replace(g, `${e}${x}${g}`) : p = `${p}${e}${x}`), n && $ ? `${p}${$}${n}` : g && $ ? p.replace(g, `${$}${g}`) : g && n ? p.replace(g, `${$}${n}`) : [p, $, n].join("");
}, Le = (a, r, e) => {
  let l = a;
  return r && r !== "." && (l = l.replace(RegExp(b(r), "g"), "."), e && r === "-" && (l = `-${l.slice(1)}`)), l;
}, Ae = (a, { prefix: r, groupSeparator: e, decimalSeparator: l, decimalScale: i, disableGroupSeparators: t = !1 }) => a.reduce((n, { type: o, value: u }, m) => m === 0 && r ? o === "minusSign" ? [u, r] : o === "currency" ? [...n, r] : [r, u] : o === "currency" ? r ? n : [...n, u] : o === "group" ? t ? n : [...n, e !== void 0 ? e : u] : o === "decimal" ? i !== void 0 && i === 0 ? n : [...n, l !== void 0 ? l : u] : o === "fraction" ? [...n, i !== void 0 ? u.slice(0, i) : u] : [...n, u], [""]).join(""), Ke = { currencySymbol: "", groupSeparator: "", decimalSeparator: "", prefix: "", suffix: "" }, Pe = (a) => {
  let { locale: r, currency: e, ...l } = a || {};
  return (r ? new Intl.NumberFormat(r, { ...l, ...e && { currency: e, style: "currency" } }) : new Intl.NumberFormat()).formatToParts(1000.1).reduce((i, t, n) => t.type === "currency" ? n === 0 ? { ...i, currencySymbol: t.value, prefix: t.value } : { ...i, currencySymbol: t.value, suffix: t.value } : t.type === "group" ? { ...i, groupSeparator: t.value } : t.type === "decimal" ? { ...i, decimalSeparator: t.value } : i, Ke);
}, ie = (a) => RegExp(/\d/, "gi").test(a), Me = (a, r, e) => {
  if (e === void 0 || r === "" || r === void 0 || a === "" || a === void 0) return a;
  if (!a.match(/\d/g)) return "";
  let [l, i] = a.split(r);
  if (e === 0) return l;
  let t = i || "";
  if (t.length < e) for (; t.length < e; ) t += "0";
  else t = t.slice(0, e);
  return `${l}${r}${t}`;
}, Te = ({ selectionStart: a, value: r, lastKeyStroke: e, stateValue: l, groupSeparator: i }) => {
  let t = a, n = r;
  if (l && t) {
    let o = r.split("");
    return e === "Backspace" && l[t] === i && (o.splice(t - 1, 1), t -= 1), e === "Delete" && l[t] === i && (o.splice(t, 1), t += 1), n = o.join(""), { modifiedValue: n, cursorPosition: t };
  }
  return { modifiedValue: n, cursorPosition: a };
}, pe = oe(({ allowDecimals: a = !0, allowNegativeValue: r = !0, id: e, name: l, className: i, customInput: t, decimalsLimit: n, defaultValue: o, disabled: u = !1, maxLength: m, value: f, onValueChange: w, fixedDecimalLength: R, placeholder: L, decimalScale: p, prefix: g, suffix: $, intlConfig: x, step: V, min: D, max: N, disableGroupSeparators: T = !1, disableAbbreviations: _ = !1, decimalSeparator: H, groupSeparator: O, onChange: X, onFocus: Y, onBlur: j, onKeyDown: Z, onKeyUp: ee, transformRawValue: se, formatValueOnBlur: de = !0, ...me }, fe) => {
  if (H && ie(H)) throw new Error("decimalSeparator cannot be a number");
  if (O && ie(O)) throw new Error("groupSeparator cannot be a number");
  let B = Ee(() => Pe(x), [x]), s = H || B.decimalSeparator || "", F = O || B.groupSeparator || "";
  if (s && F && s === F && T === !1) throw new Error("decimalSeparator cannot be the same as groupSeparator");
  let A = { decimalSeparator: s, groupSeparator: F, disableGroupSeparators: T, intlConfig: x, prefix: g || B.prefix, suffix: $ }, U = { decimalSeparator: s, groupSeparator: F, allowDecimals: a, decimalsLimit: n || R || 2, allowNegativeValue: r, disableAbbreviations: _, prefix: g || B.prefix, transformRawValue: se }, [S, K] = P(() => o != null ? M({ ...A, decimalScale: p, value: String(o) }) : f != null ? M({ ...A, decimalScale: p, value: String(f) }) : ""), [W, ge] = P(!1), [q, z] = P(0), [re, ve] = P(0), [Se, $e] = P(null), C = Q(null);
  ue(fe, () => C.current);
  let te = (d, h) => {
    ge(!0);
    let { modifiedValue: v, cursorPosition: y } = Te({ selectionStart: h, value: d, lastKeyStroke: Se, stateValue: S, groupSeparator: F }), c = J({ value: v, ...U });
    if (m && c.replace(/-/g, "").length > m) return;
    if (c === "" || c === "-" || c === s) {
      w && w(void 0, l, { float: null, formatted: "", value: "" }), K(c), z(1);
      return;
    }
    let E = s ? c.replace(s, ".") : c, k = parseFloat(E), I = M({ value: c, ...A });
    if (y != null) {
      let G = y + (I.length - d.length);
      G = G <= 0 ? g ? g.length : 0 : G, z(G), ve(re + 1);
    }
    K(I), w && w(c, l, { float: k, formatted: I, value: c });
  }, he = (d) => {
    let { target: { value: h, selectionStart: v } } = d;
    te(h, v), X && X(d);
  }, xe = (d) => (Y && Y(d), S ? S.length : 0), we = (d) => {
    let { target: { value: h } } = d, v = J({ value: h, ...U });
    if (v === "-" || v === s || !v) {
      K(""), j && j(d);
      return;
    }
    let y = Ie(v, s, R), c = Me(y, s, p !== void 0 ? p : R), E = s ? c.replace(s, ".") : c, k = parseFloat(E), I = M({ ...A, value: c });
    w && de && w(c, l, { float: k, formatted: I, value: c }), K(I), j && j(d);
  }, ye = (d) => {
    let { key: h } = d;
    if ($e(h), V && (h === "ArrowUp" || h === "ArrowDown")) {
      d.preventDefault(), z(S.length);
      let v = f != null ? String(f) : void 0, y = s && v ? v.replace(s, ".") : v, c = parseFloat(y ?? J({ value: S, ...U })) || 0, E = h === "ArrowUp" ? c + V : c - V;
      if (D !== void 0 && E < Number(D) || !r && E < 0 || N !== void 0 && E > Number(N)) return;
      let k = String(V).includes(".") ? Number(String(V).split(".")[1].length) : void 0;
      te(String(k ? E.toFixed(k) : E).replace(".", s));
    }
    Z && Z(d);
  }, be = (d) => {
    let { key: h, currentTarget: { selectionStart: v } } = d;
    if (h !== "ArrowUp" && h !== "ArrowDown" && S !== "-") {
      let y = ce(S, { groupSeparator: F, decimalSeparator: s });
      if (y && v && v > S.length - y.length && C.current) {
        let c = S.length - y.length;
        C.current.setSelectionRange(c, c);
      }
    }
    ee && ee(d);
  };
  ne(() => {
    f == null && o == null && K("");
  }, [o, f]), ne(() => {
    W && S !== "-" && C.current && document.activeElement === C.current && C.current.setSelectionRange(q, q);
  }, [S, q, C, W, re]);
  let ae = { type: "text", inputMode: "decimal", id: e, name: l, className: i, onChange: he, onBlur: we, onFocus: xe, onKeyDown: ye, onKeyUp: be, placeholder: L, disabled: u, value: f != null && S !== "-" && (!s || S !== s) ? M({ ...A, decimalScale: W ? void 0 : p, value: String(f) }) : S, ref: C, ...me };
  return t ? le.createElement(t, { ...ae }) : le.createElement("input", { ...ae });
});
pe.displayName = "CurrencyInput";
var je = pe, Be = je;
const Ge = ({ onChange: a, value: r, ...e }, l) => {
  const i = Q(null), t = Q(null);
  ue(l, () => i.current);
  const n = Ve((o) => {
    i.current = o;
  }, []);
  return Ne(() => {
    const o = i.current, u = t.current;
    if (t.current = null, !o || !u || document.activeElement !== o)
      return;
    const m = o.value.length - u.lengthBefore, f = Math.max(
      0,
      Math.min(o.value.length, u.selectionStart + m)
    );
    o.setSelectionRange(f, f);
  }, [r]), /* @__PURE__ */ Re(
    Be,
    {
      ...e,
      value: r,
      ref: n,
      onChange: (o) => {
        const u = i.current;
        u && u.selectionStart != null && (t.current = {
          selectionStart: u.selectionStart,
          lengthBefore: u.value.length
        }), a?.(o);
      }
    }
  );
}, Oe = oe(Ge);
export {
  Oe as CurrencyInput
};
